export const telephoneNumbers = {
  customerServices: '021 202 9119',
  newSales: '021 202 9119',
} as const;
